export class Webp {
  webpStatus: boolean;
  autoOptimize: boolean;
  hosting: string;
  htaccessWritable: boolean;
  webpDeliveryWorking: string;
  pictureWebpStatus: boolean;
}
